import React from 'react'
import BaseIcon from 'react-icon-base'

const AE = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 12 6" {...props}>
    <title>Flag of United Arab Emirates (Dubai)</title>
    <rect width="12" height="2" fill="#00732f" id="green" />
    <rect width="12" height="2" y="2" fill="#fff" />
    <rect width="12" height="2" y="4" />
    <rect width="3" height="6" fill="#f00" id="red" />
  </BaseIcon>
)

export default AE
